import { Record } from 'immutable'

export interface ITenantRent {
  readonly description: string
  readonly rentAmount: number
}

const TenantRentRecord = Record({
  description: '',
  rentAmount: 0,
})

export class TenantRent extends TenantRentRecord implements ITenantRent {
  public static fromJS(initialState?: Partial<ITenantRent>) {
    return new TenantRent(initialState)
  }

  public readonly description: string
  public readonly rentAmount: number

  constructor(props?: Partial<TenantRent>) {
    props ? super(props) : super()
  }
}
